import React from 'react'

import {
  AlignSelf,
  BorderStyle,
  Box,
  Color,
  Display,
  FlexDirection,
} from '@gousto-internal/citrus-react'

import { RafCampaignDetails } from '../../../hooks/useFetchRafCampaignDetails'
import styled from '@emotion/styled'
import { MobileDiscountBox } from './MobileDiscountBox'

const DiscountsContainer = styled(Box)`
  height: 108px;
`

export const DiscountBoxesThreeTierMobile = ({
  firstBoxDiscount,
  firstMonthDiscount,
  secondBoxDiscount,
}: Omit<RafCampaignDetails, 'giftYourFriendCredit'>) => (
  <DiscountsContainer display={Display.Flex} flexDirection={FlexDirection.Row}>
    <MobileDiscountBox
      discount={firstBoxDiscount}
      bgColor={Color.Primary_600}
      detailText="1st box"
    ></MobileDiscountBox>
    <Box
      minWidth={'16px'}
      height={'0'}
      borderColor={Color.ColdGrey_200}
      borderStyle={BorderStyle.Solid}
      borderBottomWidth={1}
      alignSelf={AlignSelf.Center}
    ></Box>
    <MobileDiscountBox
      discount={secondBoxDiscount!}
      bgColor={Color.ColdGrey_800}
      detailText="2nd box"
    ></MobileDiscountBox>
    <Box
      minWidth={'16px'}
      height={'0'}
      borderColor={Color.ColdGrey_200}
      borderStyle={BorderStyle.Solid}
      borderBottomWidth={1}
      alignSelf={AlignSelf.Center}
    ></Box>
    <MobileDiscountBox
      discount={firstMonthDiscount}
      bgColor={Color.ColdGrey_800}
      detailText="For 2 months"
    ></MobileDiscountBox>
  </DiscountsContainer>
)
